const { addActions } = require('js-data-http')

let mapper_options = {
  endpoint: 'brand_requests',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      brand: {
        foreignKey: 'brand_id',
        localField: 'brand'
      },
      retailer_account: {
        foreignKey: 'retailer_account_id',
        localField: 'retailer_account'
      },
      user: {
        foreignKey: 'rep_id',
        localField: 'rep'
      },
      user: {
        foreignKey: 'assignee_id',
        localField: 'assignee'
      }
    }
  }
}

module.exports = (store) => {
  let mapper = store.defineMapper('brand_request', mapper_options)
  addActions({
    accept: {
      pathname: 'accept',
      method: 'PUT'
    },
    revoke: {
      pathname: 'revoke',
      method: 'PUT'
    },
    reaccept: {
      pathname: 'reaccept',
      method: 'PUT'
    }
  })(mapper)
}
